import { render, staticRenderFns } from "./MailPopup.vue?vue&type=template&id=99ebb704"
import script from "./MailPopup.vue?vue&type=script&lang=js"
export * from "./MailPopup.vue?vue&type=script&lang=js"
import style0 from "./MailPopup.vue?vue&type=style&index=0&id=99ebb704&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports